export const accountingRenewalInfoTabs = [
	{
		name: 'Accounting Renewal',
		path: 'companies/accounting-renewal/info',
		alternativePath: 'companies/accounting-renewal/info/:id'
	},
];
